export function resumeCameraPreview(event) {
    const video = event.currentTarget;
    if (!video.isConnected || !video.srcObject || !video.srcObject.active) return;

    try {
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    } catch (error) {
        // O Safari pode suspender a reprodução quando o aplicativo fica em segundo plano.
    }
}
